export default __webpack_public_path__ + "static/media/error.8f1439e5.svg";